import Account from "./Account";
// import {useBlock} from './BlockComponent';
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchMyself, selectUsers } from "../features/users/usersSlice";

export default function AccountContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");
  let coreUser = localStorage.getItem("coreUser");
  const { userAccount, error, loading } = useSelector(selectUsers);
  const dispatch = useDispatch();

  // get user by username search
  useEffect(() => {
    dispatch(
      fetchMyself({
        token: jwtToken,
        // user: coreUser,
      })
    );
  }, [dispatch]);

  const [ready, setReady] = useState(false);
  if (loading === "loaded" && !ready) {
    setReady(true);
  }
  return (
    <div>
      {ready && (
        <Account error={error} loading={loading} userAccount={userAccount} />
      )}
    </div>
  );
}
